<template>
  <div class='score'>
    <monitorHead title="Google Pagespeed评分"
                 :img="img"
                 :text="text"></monitorHead>
    <div class="pagespeed">
      <div class="folding_head">
        <div class="left">
          <span class="left_text">Pagespeed评分</span>
        </div>
        <div class="right">
          <div class="right_text">评分：{{details.pageSpeed.totalScore}}</div>
          <div class="right_arrow"
               @click="showOne=!showOne">
            <ig-icon name="jiantou"></ig-icon>
          </div>
        </div>
      </div>
      <div class="folding_body"
           v-show="showOne">
        <div class="folding_item"
             v-for="(item,index) in pagespeedList"
             :key="index">
          <div class="left">
            <div class="left_color"
                 :style="`backgroundColor:${item.color()}`"></div>
            <div class="left_label">{{item.label}}</div>
          </div>
          <div class="right"
               :style="`color:${item.color()}`">{{item.text}}</div>
        </div>
      </div>
    </div>
    <div class="indicators">
      <div class="indicators_header">
        <span>指标详情</span>
        <el-switch v-model="indicatorsShow">
        </el-switch>
      </div>
      <div class="indicators_body">
        <div class="indicators_item"
             v-for="(item,index) in indicatorsList"
             :key="index">
          <div class="indicators_color"
               style="backgroundColor:#FCE06C">
          </div>
          <div class="indicators_item_body">
            <div class="indicators_item_top">
              <div class="indicators_label">
                {{item.label}}
              </div>
              <div class="indicators_value">
                {{item.value}}
              </div>
            </div>
            <div class="indicators_item_bottom"
                 v-if="indicatorsShow">
              {{item.text}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="structure">
      <div class="folding_head">
        <div class="left">
          <span class="left_text">Structure评估</span>
        </div>
        <div class="right">
          <div class="right_text">评分：{{details.yslowScore}}</div>
          <div class="right_arrow"
               @click="showTwo=!showTwo">
            <ig-icon name="jiantou"></ig-icon>
          </div>
        </div>
      </div>
      <div class="folding_body"
           v-show="showTwo">
        <div class="folding_item"
             v-for="(item,index) in structureList"
             :key="index">
          <div class="left">
            <div class="left_color_two"
                 :style="`backgroundColor:${item.color()}`">{{item.tips}}</div>
            <div class="left_label">{{item.label}}</div>
          </div>
          <div class="right"
               :style="`color:${item.color()}`">{{item.text}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import monitorHead from './monitorHead';
import img from '@/assets/websiteMonitor/googlePagespeed.png';

export default {
  name: 'score',
  props: ['details'],
  components: {
    monitorHead
  },
  data () {
    return {
      img,
      text: '全球赢采用适合Google搜索引擎优化的网站架构、页面加载及压缩技术提升网站的站点评分；分数越高谷歌搜索排名也会越高，网站投放广告也会有益处，体验也会更好。',
      showOne: true,
      showTwo: true,
      indicatorsShow: false,
    }
  },
  computed: {
    pagespeedList (self) {
      let { pageSpeed } = self.details
      let { fcp, tti, si, tbt, lcp, cls } = pageSpeed
      return [
        {
          label: '首屏加载时间',
          text: `${fcp}ms`,
          color: () => {
            if (fcp >= 0 && fcp < 900) return '#43B58E'
            else if (fcp >= 900 && fcp < 1200) return '#FCE06C'
            else if (fcp >= 1200) return '#ED4F28'
            else return '#ED4F28'
          },
        },
        {
          label: '交互时间',
          text: `${(tti / 1000).toFixed(1)}s`,
          color: () => {
            let ttiCopy = (tti / 1000).toFixed(1)
            if (ttiCopy >= 0 && ttiCopy < 2.5) return '#43B58E'
            else if (ttiCopy >= 2.5 && ttiCopy < 3.5) return '#FCE06C'
            else if (ttiCopy >= 3.5) return '#ED4F28'
            else return '#ED4F28'
          },
        },
        {
          label: '速度指标',
          text: `${(si / 1000).toFixed(1)}s`,
          color: () => {
            let siCopy = (si / 1000).toFixed(1)
            if (siCopy >= 0 && siCopy < 1.3) return '#43B58E'
            else if (siCopy >= 1.3 && siCopy < 1.8) return '#FCE06C'
            else if (siCopy >= 1.8) return '#ED4F28'
            else return '#ED4F28'
          },
        },
        {
          label: '总阻塞时间',
          text: `${tbt}ms`,
          color: () => {
            if (tbt >= 0 && tbt < 150) return '#43B58E'
            else if (tbt >= 150 && tbt < 500) return '#FCE06C'
            else if (tbt >= 500) return '#ED4F28'
            else return '#ED4F28'
          },
        },
        {
          label: '最大内容加载时间',
          text: `${(lcp / 1000).toFixed(1)}s`,
          color: () => {
            let lcpCopy = (lcp / 1000).toFixed(1)
            if (lcpCopy >= 0 && lcpCopy < 1.2) return '#43B58E'
            else if (lcpCopy >= 1.2 && lcpCopy < 3) return '#FCE06C'
            else if (lcpCopy >= 3) return '#ED4F28'
            else return '#ED4F28'
          },
        },
        {
          label: '累计版面偏移',
          text: cls,
          color: () => {
            if (cls >= 0 && cls < 0.1) return '#43B58E'
            else if (cls >= 0.1 && cls < 0.2) return '#FCE06C'
            else if (cls >= 0.2) return '#ED4F28'
            else return '#ED4F28'
          },
        },
      ]
    },
    indicatorsList (self) {
      let { redirectDuration, connectDuration, backendDuration, htmlLoadTime, firstPaintTime, firstContentfulPaintTime, domInteractiveTime, domContentLoadedTime, onloadTime } = self.details
      return [
        {
          label: '重定向',
          value: `${redirectDuration}ms`,
          text: '这是在加载最终 HTML 页面之前重定向 URL 所花费的时间。'
        },
        {
          label: '连接时间',
          value: `${connectDuration}ms`,
          text: '这是在所有重定向之后连接到服务器以向页面发出请求所花费的时间。'
        },
        {
          label: '后端连接时间',
          value: `${backendDuration}ms`,
          text: '这是服务器生成初始响应所需的时间。'
        },
        {
          label: '到第一个节点的时间',
          value: `${htmlLoadTime}ms`,
          text: '这是从请求开始到我们收到响应的第一个字节的总时间。'
        },
        {
          label: '初涂时间',
          value: `${firstPaintTime}ms`,
          text: '这个时间是浏览器在页面上进行任何类型渲染的第一个时间点。'
        },
        {
          label: '绘画时间',
          value: `${(firstContentfulPaintTime / 1000).toFixed(1)}s`,
          text: '此时间发生在页面处理完成并且所有页面资源都下载完成时。'
        },
        {
          label: 'DOM互动时间',
          value: `${(domInteractiveTime / 1000).toFixed(1)}s`,
          text: '这是 DOM 准备就绪并且没有样式表阻止 JavaScript 执行的时间。'
        },
        {
          label: 'DOM内容加载时间',
          value: `${(domContentLoadedTime / 1000).toFixed(1)}s`,
          text: '这个时间是浏览器完成加载和解析 HTML 并且构建 DOM 的时间。'
        },
        {
          label: '满载时间',
          value: `${(onloadTime / 1000).toFixed(1)}s`,
          text: '这是 FCP 和 Onload 触发后的最长时间，并且在捕获最后一个请求后存在网络和 CPU 空闲（每个 5.25 秒）'
        },
      ]
    },
    structureList (self) {
      let { yslowList } = self.details
      let list = yslowList.sort((a, b) => {
        return b.score - a.score
      })
      return list.map(item => {
        let { title, score, level } = item
        return {
          tips: level,
          label: title,
          text: score || '-',
          color: () => {
            if (score >= 80) return '#43B48E'
            else if (score < 80 && score >= 60) return '#FCE170'
            else if (score < 60) return '#ED5028'
            else return '#ED5028'
          },
        }
      })
    }
  },
}
</script>

<style lang='scss' scoped>
.score {
	background: #ffffff;
	box-shadow: 0px 4px 4px 0px rgba(67, 93, 255, 0.05);
	margin-bottom: 10px;
	padding: 0 100px 50px;

	.folding_head {
		height: 60px;
		display: flex;
		font-size: 13pt;
		align-items: center;
		justify-content: space-between;
		border-radius: 5pt;
		overflow: hidden;
		box-shadow: 3px 4px 5px 5px rgba(192, 192, 192, 0.1);
		margin-bottom: 20px;
		margin-top: 20px;

		.left {
			.left_text {
				font-weight: 500;
				color: #3da1ff;
				margin-left: 10pt;
			}
		}

		.right {
			height: 100%;
			display: flex;
			align-items: center;

			.right_text {
				text-align: center;
				font-size: 24px;
				font-weight: 600;
				margin-right: 10px;
			}

			.right_arrow {
				background-color: #3da1ff;
				height: 100%;
				width: 60px;
				display: flex;
				justify-content: center;
				align-items: center;

				.iconfont {
					font-size: 30px;
					color: #ffffff;
				}

				&:hover {
					cursor: pointer;
				}
			}
		}
	}

	.folding_body {
		display: grid;
		grid-template-columns: repeat(3, 32.2%);
		grid-row-gap: 5px;
		grid-column-gap: 20px;

		.folding_item {
			border-radius: 5px;
			overflow: hidden;
			box-shadow: 3px 4px 5px 5px rgba(192, 192, 192, 0.1);
			margin: 10px 0;
			display: flex;
			justify-content: space-between;
			height: 40px;

			.left {
				display: flex;
				align-items: center;
				flex: 1;
				width: 0;

				.left_color {
					width: 10px;
					height: 100%;
				}

				.left_color_two {
					height: 100%;
					color: #ffffff;
					padding: 0 5px;
					display: flex;
					justify-content: center;
					align-items: center;
					font-size: 15px;
					width: 60px;
				}

				.left_label {
					font-size: 15px;
					font-weight: 600;
					margin-left: 10px;
					flex: 1;
					width: 0;
					overflow: hidden; //超出的文本隐藏
					text-overflow: ellipsis; //溢出用省略号显示
					white-space: nowrap; //溢出不换行
				}
			}

			.right {
				display: flex;
				align-items: center;
				margin-right: 10px;
				font-size: 15px;
			}
		}
	}

	.indicators {
		margin-top: 20px;

		.indicators_header {
			font-size: 15px;
			display: flex;
			justify-content: flex-end;
			align-items: center;

			span {
				margin-right: 10px;
			}
		}

		.indicators_body {
			display: grid;
			grid-template-columns: repeat(3, 32.2%);
			grid-row-gap: 5px;
			grid-column-gap: 20px;

			.indicators_item {
				border-radius: 5px;
				overflow: hidden;
				box-shadow: 3px 4px 5px 5px rgba(192, 192, 192, 0.1);
				margin: 10px 0;
				display: flex;

				.indicators_color {
					width: 10px;
				}

				.indicators_item_body {
					flex: 1;
					width: 0;
					padding: 10px 10px;

					.indicators_item_top {
						display: flex;
						align-items: center;
						justify-content: space-between;

						.indicators_label {
							font-size: 15px;
							font-weight: 600;
						}

						.indicators_value {
							font-size: 15px;
						}
					}

					.indicators_item_bottom {
						margin-top: 10px;
						font-size: 15px;
					}
				}
			}
		}
	}
}
</style>
